import { Button, Form, Radio } from "antd";
import KnetIcon from "../../assets/images/payment-methods-icon/knet-icon.svg";
import TockenIcon from "../../assets/images/payment-methods-icon/tocken-icon.svg";
import AppleIcon from "../../assets/images/payment-methods-icon/apple-icon.svg";
import CreditIcon from "../../assets/images/payment-methods-icon/credit-icon.svg";
import GoogleIcon from "../../assets/images/payment-methods-icon/google-icon.svg";
import { useState } from "react";
import UniversalModal from "../../components/UniversalModal";
const walletSummaryData = JSON.parse(localStorage.getItem("walletSummary"));

const PaymentMethods = ({ savedInfo, setSavedInfo, form }) => {
  const [isModal, setIsModal] = useState({
    open: false,
    title: "",
    message: "",
    buttonText: "",
  });
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [savePayment, setSavePayment] = useState(false);
  return (
    <>
      <Form.Item
        name="method"
        rules={[{ required: true, message: "Please select a payment method" }]}
      >
        <Radio.Group
          className="payment-radio-group"
          value={selectedMethod}
          onChange={(e) => setSelectedMethod(e.target.value)}
        >
          <Radio value="knet">
            <div className="radio-inner-bt">
              <img src={KnetIcon} alt="logo" /> KNET
            </div>
          </Radio>
          <Radio value="token">
            <div className="radio-inner-bt">
              <img src={TockenIcon} alt="logo" />
              <span>
                Tokens{" "}
                <div className="token-amount" style={{ color: "white" }}>
                  Available:{" "}
                  <span>{walletSummaryData?.wallet?.total_balance} TKN</span>
                </div>{" "}
              </span>{" "}
            </div>
          </Radio>
          <Radio value="apple-pay">
            <div className="radio-inner-bt">
              <img src={AppleIcon} alt="logo" /> Apple Pay
            </div>
          </Radio>
          <Radio value="cc">
            <div className="radio-inner-bt">
              <img src={CreditIcon} alt="logo" />
              Credit Card{" "}
            </div>
          </Radio>
          <Radio value="google-pay">
            <div className="radio-inner-bt">
              <img src={GoogleIcon} alt="logo" /> Google Pay{" "}
            </div>
          </Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item shouldUpdate noStyle>
        {({ setFieldsValue }) => (
          <Button
            className="Fill-button"
            onClick={() => {
              if (selectedMethod) {
                setFieldsValue({ method: selectedMethod });
                setIsModal({
                  open: true,
                  title: "Payment Confirmation",
                  message: `Selected payment method: ${selectedMethod}`,
                  buttonText: "Done",
                });
                setSavePayment(true);
                setSavedInfo({ ...savedInfo, payInfo: true });
              } else {
                setIsModal({
                  open: true,
                  title: "Payment Required",
                  message: "Please select a payment method",
                  buttonText: "Back",
                });
              }
            }}
          >
            {savePayment ? "Payment Confirmed" : "Confirm Payment"}
          </Button>
        )}
      </Form.Item>
      {/*  modal */}
      <UniversalModal
        open={isModal.open}
        onClose={() => setIsModal(false)}
        title={isModal.title}
        message={isModal.message}
        footerButtonLabel={isModal.buttonText}
      />
    </>
  );
};

export default PaymentMethods;
